import * as Business         from '../../business';
import { compose }           from 'redux';
import { connect }           from 'react-redux';
import { Fragment }          from 'react';
import { getNextdoorStatus } from '../business_profile_page';
import { useCallback }       from 'react';
import ConnectProfile        from './connect_profile_view';
import DisconnectProfile     from './disconnect_profile_view';
import FetchFromServer       from '../../components/fetch_from_server';
import Navbar                from '../../components/navbar';
import React                 from 'react';


export default connect(
  (state, { businessID }) => ({
    statuses: Business.getBusinessStatuses(state, businessID),
    business: Business.getBusiness(state, businessID),
    profile:  Business.getNextdoorProfile(state, businessID)
  }),
  (dispatch, { businessID }) => ({
    load:              compose(dispatch, Business.loadBusiness, () => (businessID)),
    connectProfile:    compose(dispatch, Business.connectNextdoorProfile, id => ({ businessID, id })),
    disconnectProfile: compose(dispatch, Business.disconnectNextdoorProfile, () => ({ businessID }))
  })
)(NextdoorPage);


export function NextdoorPage({
  business,
  statuses,
  load,
  profile,
  connectProfile,
  disconnectProfile,
  navigateBackTo
}) {

  const status      = business && getNextdoorStatus(business);
  const isConnected = status === 'Connected';

  const disconnect = useCallback(() => {
    disconnectProfile();
    navigateBackTo('../');
  }, [ disconnectProfile, navigateBackTo ]);

  return (
    <Fragment>
      <Navbar title="Nextdoor"/>
      <FetchFromServer statuses={statuses} load={load} className="settings business-profile nextdoor">
        {!isConnected && (
          <ConnectProfile
            name="Nextdoor"
            connectProfile={connectProfile}
            placeholder="https://nextdoor.com/pages/..."
            getProfileID={getProfileID}
          />
        )}

        {isConnected && profile && (
          <DisconnectProfile
            name="Nextdoor"
            profileURL={`https://nextdoor.com/pages/${profile.id}`}
            disconnectProfile={disconnect}
          />
        )}
      </FetchFromServer>
    </Fragment>
  );
}


function getProfileID(url) {
  const urlRegex = /(https?:\/\/)?(www\.)?nextdoor\.com\/pages\/([^?/#]+)/;
  const match    = url.match(urlRegex);
  if (match)
    return match[3];
  else
    return null;
}
